<template>
  <div id="createOrderModal" class="modal" :class="{'show': isShow}">
    <!-- Modal content -->
    <div class="modal-content">
      <div class="row">
        <div class="col-md-3 col-md-offset-11">
          <v-icon @click="hide">mdi-close</v-icon>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 mt-5">
          <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
            <a class="btn btn-primary btn-block" id="v-order-data-tab" data-toggle="pill" href="#v-order-data"
               role="tab" aria-controls="order-home" aria-selected="true">{{ $t('page.order.create.data') }}</a>
            <a class="btn btn-primary btn-block" id="v-order-shipto-tab" data-toggle="pill" href="#v-order-shipto"
               role="tab" aria-controls="order-shipto" aria-selected="false">{{ $t('page.order.create.shipto') }}</a>
            <a class="btn btn-primary btn-block" id="v-order-billto-tab" data-toggle="pill" href="#v-order-billto"
               role="tab" aria-controls="order-billto" aria-selected="false">{{ $t('page.order.create.billto') }}</a>
            <a class="btn btn-primary btn-block" id="v-order-items-tab" data-toggle="pill" href="#v-order-items"
               role="tab" aria-controls="order-items" aria-selected="false">{{ $t('page.order.create.items') }}</a>
            <!--a class="btn btn-primary btn-block" id="v-order-shipping-tab" data-toggle="pill" href="#v-order-shipping" role="tab" aria-controls="order-shipping" aria-selected="false">{{$t('page.order.create.shipping')}}</a-->
          </div>
        </div>

        <div class="col-md-9">
          <div class="tab-content" id="v-product-tabContent">
            <div class="tab-pane fade active in" id="v-order-data" role="tabpanel" aria-labelledby="v-order-data-tab">
              <h3>{{ $t('page.order.create.data') }}</h3>
              <div class="row"><label>{{ $t('page.order.create.abteilung') }}</label>
                <select v-model="order.abteilungId" id="order_abteilung" class="form-control">
                  <option value="-1">{{ $t('page.order.create.choose_abteilung') }}</option>
                  <option v-for="department in availableDepartments" :value="department.id">{{ department.name }}
                  </option>
                </select>
              </div>
              <div class="row"><label>{{ $t('page.order.create.status') }}</label>
                <select v-model="order.orderStatus" id="order_status" class="form-control">
                  <option value="-1">{{ $t('page.order.create.choose_status') }}</option>
                  <option v-for="status in availableStatus" :value="status.id">{{ status.status }}</option>
                </select>
              </div>
              <div class="row"><label>{{ $t('page.order.create.shipping_methods') }}</label>
                <select v-model="order.shippingMethod" id="shipping_method" class="form-control">
                  <option value="-1">{{ $t('page.order.create.choose_shipping_method') }}</option>
                  <option v-for="method in availableShippingMethods" :value="method.id">{{ method.name }}</option>
                </select>
              </div>
              <div class="row"><label>{{ $t('page.order.create.ordernumber') }}</label><input class="form-control"
                                                                                              type="text"
                                                                                              id="order_ordernumber"
                                                                                              :placeholder="$t('page.order.create.ordernumber')"
                                                                                              v-model="order.orderNumber"/>
              </div>
              <div class="row"><label>{{ $t('page.order.create.externordernumber') }}</label><input class="form-control"
                                                                                                    type="text"
                                                                                                    id="order_externordernumber"
                                                                                                    :placeholder="$t('page.order.create.externordernumber')"
                                                                                                    v-model="order.extern_id"/>
              </div>
              <div class="row"><label>{{ $t('page.order.create.cod') }}</label><input class="form-control" type="text"
                                                                                      id="order_cod"
                                                                                      :placeholder="$t('page.order.create.cod')"
                                                                                      v-model="order.cod"/></div>

            </div>

            <div class="tab-pane fade in" id="v-order-shipto" role="tabpanel" aria-labelledby="v-order-shipto-tab">
              <h3>{{ $t('page.order.create.shipto') }}</h3>
              <div class="row"><label>{{ $t('page.order.create.firstname') }}</label><input class="form-control"
                                                                                            type="text"
                                                                                            id="order_shipto_firstname"
                                                                                            :placeholder="$t('page.order.create.firstname')"
                                                                                            v-model="order.shipTo.firstname"/>
              </div>
              <div class="row"><label>{{ $t('page.order.create.lastname') }}</label><input class="form-control"
                                                                                           type="text"
                                                                                           id="order_shipto_lastname"
                                                                                           :placeholder="$t('page.order.create.lastname')"
                                                                                           v-model="order.shipTo.lastname"/>
              </div>
              <div class="row"><label>{{ $t('page.order.create.company') }}</label><input class="form-control"
                                                                                          type="text"
                                                                                          id="order_shipto_company"
                                                                                          :placeholder="$t('page.order.create.company')"
                                                                                          v-model="order.shipTo.company"/>
              </div>
              <div class="row"><label>{{ $t('page.order.create.street') }}</label><input class="form-control"
                                                                                         type="text"
                                                                                         id="order_shipto_street"
                                                                                         :placeholder="$t('page.order.create.street')"
                                                                                         v-model="order.shipTo.street"/>
              </div>
              <div class="row"><label>{{ $t('page.order.create.housenumber') }}</label><input class="form-control"
                                                                                              type="text"
                                                                                              id="order_shipto_housenumber"
                                                                                              :placeholder="$t('page.order.create.housenumber')"
                                                                                              v-model="order.shipTo.housenumber"/>
              </div>


              <div class="row"><label>{{ $t('page.order.create.additional_lines') }}</label>
                <textarea class="form-control" id="order_shipto_additional_lines"
                          :placeholder="$t('page.order.create.additional_lines')"
                          v-model="order.shipTo.additionalLines"></textarea>
              </div>
              <div class="row"><label>{{ $t('page.order.create.plz') }}</label><input class="form-control" type="text"
                                                                                      id="order_shipto_plz"
                                                                                      :placeholder="$t('page.order.create.plz')"
                                                                                      v-model="order.shipTo.plz"/></div>
              <div class="row"><label>{{ $t('page.order.create.city') }}</label><input class="form-control" type="text"
                                                                                       id="order_shipto_city"
                                                                                       :placeholder="$t('page.order.create.city')"
                                                                                       v-model="order.shipTo.city"/>
              </div>
              <div class="row"><label>{{ $t('page.order.create.state') }}</label><input class="form-control" type="text"
                                                                                        id="order_shipto_state"
                                                                                        :placeholder="$t('page.order.create.state')"
                                                                                        v-model="order.shipTo.state"/>
              </div>
              <div class="row"><label>{{ $t('page.order.create.countrycode') }}</label><input class="form-control"
                                                                                              type="text" maxlength="2"
                                                                                              id="order_shipto_countrycode"
                                                                                              :placeholder="$t('page.order.create.countrycode')"
                                                                                              v-model="order.shipTo.countryCode"/>
              </div>
              <div class="row"><label>{{ $t('page.order.create.email') }}</label><input class="form-control" type="text"
                                                                                        id="order_shipto_email"
                                                                                        :placeholder="$t('page.order.create.email')"
                                                                                        v-model="order.shipTo.email"/>
              </div>
              <div class="row"><label>{{ $t('page.order.create.phone') }}</label><input class="form-control" type="text"
                                                                                        id="order_shipto_phone"
                                                                                        :placeholder="$t('page.order.create.phone')"
                                                                                        v-model="order.shipTo.phone"/>
              </div>
            </div>

            <div class="tab-pane fade" id="v-order-billto" role="tabpanel" aria-labelledby="v-order-billto-tab">
              <h3>{{ $t('page.order.create.billto') }}</h3>
              <div class="row"><label>{{ $t('page.order.create.same_as_shipto') }}</label><input class="form-control"
                                                                                                 type="checkbox"
                                                                                                 id="order_billto_same_as_shipto"
                                                                                                 :placeholder="$t('page.order.create.same_as_shipto')"
                                                                                                 v-model="order.billTo.same_as_shipto"/>
              </div>

              <div class="row" v-if="!order.billTo.same_as_shipto">
                <label>{{ $t('page.order.create.firstname') }}</label><input class="form-control" type="text"
                                                                             id="order_billto_firstname"
                                                                             :placeholder="$t('page.order.create.firstname')"
                                                                             v-model="order.billTo.firstname"/></div>
              <div class="row" v-if="!order.billTo.same_as_shipto"><label>{{ $t('page.order.create.lastname') }}</label><input
                  class="form-control" type="text" id="order_billto_lastname"
                  :placeholder="$t('page.order.create.lastname')" v-model="order.billTo.lastname"/></div>
              <div class="row" v-if="!order.billTo.same_as_shipto">
                <label>{{ $t('page.order.create.company') }}</label><input class="form-control" type="text"
                                                                           id="order_billto_company"
                                                                           :placeholder="$t('page.order.create.company')"
                                                                           v-model="order.billTo.company"/></div>
              <div class="row" v-if="!order.billTo.same_as_shipto">
                <label>{{ $t('page.order.create.street') }}</label><input class="form-control" type="text"
                                                                          id="order_billto_street"
                                                                          :placeholder="$t('page.order.create.street')"
                                                                          v-model="order.billTo.street"/></div>
              <div class="row" v-if="!order.billTo.same_as_shipto">
                <label>{{ $t('page.order.create.housenumber') }}</label><input class="form-control" type="text"
                                                                               id="order_billto_housenumber"
                                                                               :placeholder="$t('page.order.create.housenumber')"
                                                                               v-model="order.billTo.housenumber"/>
              </div>


              <div class="row" v-if="!order.billTo.same_as_shipto">
                <label>{{ $t('page.order.create.additional_lines') }}</label>
                <textarea class="form-control" id="order_billto_additional_lines"
                          :placeholder="$t('page.order.create.additional_lines')"
                          v-model="order.billTo.additionalLines"></textarea>
              </div>
              <div class="row" v-if="!order.billTo.same_as_shipto">
                <label>{{ $t('page.order.create.plz') }}</label><input class="form-control" type="text"
                                                                       id="order_billto_plz"
                                                                       :placeholder="$t('page.order.create.plz')"
                                                                       v-model="order.billTo.plz"/></div>
              <div class="row" v-if="!order.billTo.same_as_shipto">
                <label>{{ $t('page.order.create.city') }}</label><input class="form-control" type="text"
                                                                        id="order_billto_city"
                                                                        :placeholder="$t('page.order.create.city')"
                                                                        v-model="order.billTo.city"/></div>
              <div class="row" v-if="!order.billTo.same_as_shipto">
                <label>{{ $t('page.order.create.state') }}</label><input class="form-control" type="text"
                                                                         id="order_billto_state"
                                                                         :placeholder="$t('page.order.create.state')"
                                                                         v-model="order.billTo.state"/></div>
              <div class="row" v-if="!order.billTo.same_as_shipto">
                <label>{{ $t('page.order.create.countrycode') }}</label><input class="form-control" type="text"
                                                                               maxlength="2"
                                                                               id="order_billto_countrycode"
                                                                               :placeholder="$t('page.order.create.countrycode')"
                                                                               v-model="order.billTo.countryCode"/>
              </div>
              <div class="row" v-if="!order.billTo.same_as_shipto">
                <label>{{ $t('page.order.create.email') }}</label><input class="form-control" type="text"
                                                                         id="order_billto_email"
                                                                         :placeholder="$t('page.order.create.email')"
                                                                         v-model="order.billTo.email"/></div>
              <div class="row" v-if="!order.billTo.same_as_shipto">
                <label>{{ $t('page.order.create.phone') }}</label><input class="form-control" type="text"
                                                                         id="order_billto_phone"
                                                                         :placeholder="$t('page.order.create.phone')"
                                                                         v-model="order.billTo.phone"/></div>
            </div>

            <div class="tab-pane fade" id="v-order-items" role="tabpanel" aria-labelledby="v-order-items-tab">
              <div class="row">
                <div class="col-md-12">
                  <h3>{{ $t('page.order.create.items') }}</h3>
                  <table class="table table-responsive">
                    <thead>
                    <th class="table-icon">
                      <div class="glyphicon glyphicon-cog"></div>
                    </th>
                    <th>{{ $t('page.order.create.sku') }}</th>
                    <th>{{ $t('page.order.create.name') }}</th>
                    <th>{{ $t('page.order.create.quantity') }}</th>
                    <th>{{ $t('page.order.create.price') }}</th>
                    <th></th>
                    </thead>
                    <tbody id="product_supplier_table" :key="rerenderKey">
                    <tr>
                      <td></td>
                      <td>
                        <auto-complete-text-edit
                            :id="$id('product')"
                            :name="'product'"
                            :placeholder="$t('page.order.create.product')"
                            :url="'/order/create/complete_sku'"
                            ref="orderItemSku"
                            @newValue="setProductData"></auto-complete-text-edit>
                      </td>
                      <td><input type="text" contenteditable="false" class="form-control" id="orderItemName"
                                 ref="orderItemName" readonly/></td>
                      <td>
                        <number-input-spinner :max-value="9999" :min-value="1" :input-id="'orderItemQuantity'"/>
                      </td>
                      <td>
                        <double-input-spinner :max-value="9999" :min-value="0" :step-size="0.01"
                                              :input-id="'orderItemPrice'"/>
                      </td>
                      <td class="table-icon">
                        <div class="glyphicon glyphicon-plus gi-2x cursor-pointer" v-on:click="addOrderItem"></div>
                      </td>
                    </tr>

                    <tr v-for="(item, index) in order.items">
                      <td></td>
                      <td>{{ item.sku }}</td>
                      <td>{{ item.name }}</td>
                      <td>
                        <number-input-spinner :max-value="9999" :min-value="1" v-model="item.quantity"
                                              :input-id="$id('numberInput_'+item.sku)"/>
                      </td>
                      <td>
                        <double-input-spinner :max-value="9999" :min-value="0" :step-size="0.01"
                                              :input-id="$id('doubleInput_'+item.sku)" v-model="item.price"/>
                      </td>
                      <td class="table-icon">
                        <div class="glyphicon glyphicon-trash gi-2x cursor-pointer"
                             v-on:click="deleteOrderItem(index)"></div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-5">
            <button type="button" id="product_create_btn_u" class="form-control" v-on:click="createOrder">
              {{ $t('page.order.create.create') }}
            </button>
            <input type="hidden" id="hidden_update_field" value="" name="hidden_update_field"/>
          </div>
        </div>
      </div>
    </div>

    <question-modal :id="'errorModal'" :title="modalTitle" :message="modalMessage"/>
    <question-modal :id="'deleteBundleModal'" :title="modalTitle" :message="modalMessage" @yes="deleteRelation(true)"
                    @no="deleteRelation(false)"></question-modal>

  </div>
</template>
<script>
import AutoCompleteTextEdit from '../AutoCompleteTextEdit'
import NumberInputSpinner from "../utils/NumberInputSpinner";
import DoubleInputSpinner from "../utils/DoubleInputSpinner";

export default {
  name: "CreateOrderModal",
  private: {
    delVariationIndex: Number,
    delBundleIndex: Number,
  },
  components: {
    AutoCompleteTextEdit,
    DoubleInputSpinner,
    NumberInputSpinner,
  },
  data: function () {
    return {
      order: {
        'abteilungId': -1,
        'orderNumber': "",
        'orderStatus': -1,
        'shippingMethod': -1,
        'shipTo': {},
        'billTo': {},
        'items': [],
        'extern_id': "",
      },
      availableStatus: [],
      availableDepartments: [],
      availableShippingMethods: [],
      selectedStatus: -1,
      modalTitle: "",
      modalMessage: "",
      rerenderKey: 0,
      isShow: false
    }
  },
  props: {},
  beforeMount: function () {
    this.loadStatus();
    this.loadDepartment();
    this.loadShippingMethods();
  },
  methods: {
    loadStatus: function () {
      axios.get('/order/create/getStatus')
          .then((response) => {
            response["data"].forEach((item) => {
              this.availableStatus.push({
                'id': item.id,
                'status': item.status
              });
            });
          });
    },
    loadDepartment: function () {
      axios.get('/order/create/getDepartment')
          .then((response) => {
            response["data"].forEach((item) => {
              this.availableDepartments.push({
                'id': item.id,
                'name': item.name
              });
            });
          });
    },
    loadShippingMethods: function () {
      axios.get('/order/create/getShippingMethods')
          .then((response) => {
            response["data"].forEach( (item) => {
              this.availableShippingMethods.push({
                'id': item.id,
                'name': item.name
              });
            });
          });
    },
    setProductData: function (newValue) {
      axios.get('/order/create/getProductData/' + newValue)
          .then((response) => {
            this.$refs["orderItemName"].value = response["data"].name;
            $('#orderItemPrice').val(response["data"].price);
          });
    },
    addOrderItem: function () {
      let itemExists = false;

      this.order.items.forEach((orderItem) => {
        if (orderItem.sku === $('#' + this.$id('product') + ' input[name="product"]').val()) {
          console.log("found same item");
          itemExists = true;
          return;
        }
      });

      if (!itemExists) {
        this.order.items.push({
          sku: $('#' + this.$id('product') + ' input[name="product"]').val(),
          name: this.$refs.orderItemName.value,
          quantity: parseInt($('#orderItemQuantity').val()),
          price: parseFloat($('#orderItemPrice').val()),
        });
      } else {
        this.modalMessage = "Das Produkt kann nicht doppelt versendet werden, bitte erhöhen Sie die Anzhal.";
        this.modalTitle = "Information";
        $('#errorModal').modal('toggle');
      }
    },
    deleteOrderItem: function (index) {
      this.order.items.splice(index, 1);
      this.rerenderKey++;
    },
    createOrder: function () {
      if (this.order.billTo.same_as_shipto) {
        this.order.billTo = this.order.shipTo;
      }

      axios.post('/order/create/create', {
        data: this.order
      }).then((data) => {
        this.modalMessage = "Die Bestellung wurde erfolgreich erstellt.";
        this.modalTitle = "Bestellung eingefügt";
        $('#errorModal').modal('toggle');
        this.resetOrder();
        this.hide();
      }).catch((data) => {
        this.modalMessage = data.response.data;
        this.modalTitle = "Fehler";
        $('#errorModal').modal('toggle');
      })
    },
    show() {
      this.isShow = true;
    },
    hide() {
      this.isShow = false;
    },
    resetOrder: function () {
      this.order = {
        'abteilungId': -1,
        'orderNumber': "",
        'orderStatus': -1,
        'shippingMethod': -1,
        'shipTo': {},
        'billTo': {},
        'items': [],
        'extern_id': "",
      };
    }
  }

}
</script>

<style scoped>
.table-icon {
  width: 30px;
}

.flex-column {
  display: flex;
  display: -webkit-flex;
  flex: 1 100%;
  flex-flow: column nowrap;
}

.gi-2x {
  font-size: 2em;
}

.cursor-pointer {
  cursor: pointer;
}
</style>